import { type PropsWithChildren } from "react"
import { Link as RouterLink, type LinkProps as RouterLinkProps } from "react-router-dom"
import { Breadcrumbs, Link, TypographyProps, type LinkProps, Typography } from "@mui/material"
import { NavigateNext } from "@mui/icons-material"
import { faChevronRight } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()((theme) => ({
    root: {
        lineHeight: theme.typography.caption.lineHeight,
        fontSize: theme.typography.caption.fontSize,
        fontWeight: theme.typography.caption.fontWeight,
    }
}))

type BreadcrumbLinkProps = LinkProps & RouterLinkProps

export function BreadcrumbLink(props: BreadcrumbLinkProps) {
    return (
        <Link component={RouterLink} variant="caption" {...props} />
    )
}

type BreadcrumbProps = TypographyProps

export function Breadcrumb(props: TypographyProps) {
    return (
        <Typography variant="caption" {...props} />
    )
}

type BreadcrumbsProps = Readonly<PropsWithChildren<{}>>

export function StandardBreadcrumbs({ children }: BreadcrumbsProps) {
    const { classes } = useStyles()
    return (
        <Breadcrumbs separator={<FontAwesomeIcon icon={faChevronRight} size="xs" />} aria-label="breadcrumb" classes={{ root: classes.root }}>
            {children}
        </Breadcrumbs>
    )
}
